var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-field"},[_c('div',{staticClass:"select-field__value",class:{
      'select-field__value--opened': _vm.isOpened
    },on:{"click":function($event){_vm.isOpened = !_vm.isOpened}}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"select-field__values",class:{
      'select-field__values--visible': _vm.isOpened
    }},[_vm._l((_vm.VALUES),function(val){return [_c('div',{key:val,staticClass:"select-field__values-item",class:{
          'select-field__values-item--selected': _vm.value === val
        },on:{"click":function($event){_vm.$emit('value-changed', val); _vm.isOpened = false}}},[_vm._v(" "+_vm._s(val)+" ")])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }